import { render, staticRenderFns } from "./registroAporte.vue?vue&type=template&id=74ca021c&"
import script from "./registroAporte.vue?vue&type=script&lang=js&"
export * from "./registroAporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports